module.exports = __webpack_public_path__ + "media/src/images/student-tasks/cup-f73a3efe7848859ccd88f217c83ed64d.svg";